import {
  ADMIN_USER_STATUSES,
  DEVICE_PLATFORMS,
  DIET_TYPES,
  PLAN_STATUSES,
} from '@steado/admin-contract/users';
import { z } from 'zod';

/**
 * Filters live in the URL as typed search params, so a filtered table is a
 * shareable link and the back button works.
 *
 * Every field `.catch(undefined)`: an unrecognised value — a stale bookmark, a
 * filter that was renamed — degrades to the unfiltered list rather than
 * throwing the operator onto an error page.
 */
export const usersSearchSchema = z.object({
  search: z.string().trim().min(1).max(120).optional().catch(undefined),
  status: z.enum(ADMIN_USER_STATUSES).optional().catch(undefined),
  plan: z.enum(PLAN_STATUSES).optional().catch(undefined),
  diet: z.enum(DIET_TYPES).optional().catch(undefined),
  onboarded: z.enum(['yes', 'no']).optional().catch(undefined),
  platform: z.enum(DEVICE_PLATFORMS).optional().catch(undefined),
  /** Coached now: at any gym, at none, or at the gym whose id this is (the Gyms page's link). */
  gym: z
    .union([z.enum(['any', 'none']), z.string().uuid()])
    .optional()
    .catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

export type UsersSearch = z.infer<typeof usersSearchSchema>;
